import { GeneralInvestmentDTO } from './../../models/control-panel.model';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';

@Component({
  selector: 'scf-general-of-investment-table',
  templateUrl: './general-of-investment-table.component.html',
  styleUrls: ['./general-of-investment-table.component.scss'],
})
export class GeneralOfInvestmentTableComponent implements OnInit {
  @Input() tableRow: GeneralInvestmentDTO;
  dataSource = new MatTableDataSource<GeneralInvestmentDTO>();
  displayedColumns: string[] = [
    'calification',
    'operationNumber',
    'investment',
    'percentageOverTotal',
    'averagePl',
    'averageTIR',
  ];

  constructor() {}

  ngOnInit() {
    this.dataSource.data = [];
    this.dataSource.data.push(this.tableRow);
  }
}
